import isEqual from 'lodash/isEqual';
import find from 'lodash/find';

export default (props1, props2, keys)=>
  !find(keys, key => !isEqual(props1[key], props2[key]));